import { Fragment, useEffect } from 'react';
import { history, IRouteComponentProps } from 'umi';
import { BackButton } from '@/components/back-button/back-button';
// import PcContext from '@/utils/context';
import PolicyDetail from '@/components/policy-detail/policy-detail';
import QuoteDetail from '@/components/quote-detail/quote-detail';
import {
  getPoliciesDetail,
  getQuoteDetail,
  getPolicyDetailConfig,
} from '../service';
import { getAgencyInfo } from '@/service';
import '../style/policies.less';
import throttle from 'lodash/throttle';
import { useState } from 'react';
import SkeletonLoading from '@/components/skeleton-loading';

const PolicyDetailPage = ({ location }: IRouteComponentProps) => {
  const { query } = location;
  // const isPc = useContext(PcContext);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [policyDetail, setPolicyDetail] = useState<any>();
  const [quoteDetail, setQuoteDetail] = useState<any>();
  const [userInfo, setUserInfo] = useState<any>();
  const [DetailConfig, setDetailConfig] = useState<any>();

  const handleGetPoliciesDetail = throttle(
    async () => {
      try {
        setLoading(true);
        getPoliciesDetail({ id: query.id })
          .then((res) => {
            if (res) {
              setPolicyDetail(res.policy);
            }
          })
          .finally(() => {
            setLoading(false);
          });
      } catch (error) {
        setLoading(false);
      }
    },
    1000,
    { leading: true, trailing: false },
  );

  const handleGetDetailConfig = throttle(
    async () => {
      try {
        setLoading(true);
        getPolicyDetailConfig({
          product_type: query.product_type,
          product_key: query.product_key,
          plan_key: query.plan_key,
        })
          .then((res) => {
            if (res) {
              setDetailConfig(res.config);
            }
          })
          .finally(() => {
            setLoading(false);
          });
      } catch (error) {
        setLoading(false);
      }
    },
    1000,
    { leading: true, trailing: false },
  );

  const handleGetQuoteDetail = throttle(
    async () => {
      try {
        setLoading(true);
        getQuoteDetail({ id: query.id })
          .then((res) => {
            if (res) {
              setQuoteDetail(res.quote);
            }
          })
          .finally(() => {
            setLoading(false);
          });
      } catch (error) {
        setLoading(false);
      }
    },
    1000,
    { leading: true, trailing: false },
  );

  const getUserInfo = () => {
    getAgencyInfo().then((info: { userInfo: UserInfo }) => {
      if (info && info.userInfo) {
        setUserInfo(info.userInfo);
      }
    });
  };

  useEffect(() => {
    getUserInfo();
    if (query.tabKey === 'policy') {
      handleGetDetailConfig();
      handleGetPoliciesDetail();
    } else {
      handleGetQuoteDetail();
      handleGetDetailConfig();
    }
  }, []);

  return (
    <Fragment>
      <BackButton handleClick={() => history.goBack()} />
      {!isLoading ? (
        <div style={{ marginBottom: '100px' }}>
          {query.tabKey === 'policy'
            ? policyDetail &&
              DetailConfig && (
                <PolicyDetail
                  policyDetail={policyDetail}
                  policyDetailConfig={DetailConfig}
                />
              )
            : quoteDetail &&
              DetailConfig && (
                <QuoteDetail
                  quoteDetail={quoteDetail}
                  extId={query.ext_id}
                  quoteDetailConfig={DetailConfig}
                  userInfo={userInfo}
                />
              )}
        </div>
      ) : (
        <div style={{ marginTop: '45px' }}>
          <SkeletonLoading />
        </div>
      )}
    </Fragment>
  );
};

export default PolicyDetailPage;
